/**************************************************
 * Nombre:       Seccion_Mesas_Dia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {Add, Search, Today} from '@mui/icons-material'
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {theme} from "../../Tema";
import dayjs from "dayjs";
import 'dayjs/locale/es'
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import {buscarReservacionesDiaHora} from "../../CodNegocio/Reservas/buscarReservacionesDiaHora";
import Formulario_Fecha from "../Formularios/Formulario_Fecha";
import useRecuperarColleccionListeningToda from "../../Servicios/BD/useRecuperarColleccionListeningToda";
import {where} from "firebase/firestore";
import {ESTADOSFILA} from "../../Constantes";
import Tarjeta_Fila from "../Tarjeta/Tarjeta_Fila";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Reserva from "../Dialogos/Dialogo_Reserva";
import Dialogo_Fila from "../Dialogos/Dialogo_Fila";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Tarjeta_Sectores_Vista_Dia from "../Tarjeta/Tarjeta_Sectores_Vista_Dia";

dayjs.locale('es') // use locale

const Seccion_Mesas_Dia = () => {
    const {sCell} = useResponsive()
    const [cargar, setCargar] = useState(false);
    const [w, setW] = useState([where('estado', '==', ESTADOSFILA[0].nombre)])
    const {data} = useRecuperarColleccionListeningToda({
        col: 'filas',
        wheres: w,
        orden: 'consecutivo',
    })
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Reserva,
        titulo: 'Detalles la Reservacion',
        realizado: () => setCargar(!cargar),
    })
    const {Dialogo: DialogoFila, abrir: abrirFila} = useDialogo({
        Componente: Dialogo_Fila,
        titulo: 'Detalles del Cliente',
        realizado: () => setCargar(!cargar),
    })

    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const [fecha, setFecha] = useState(dayjs().valueOf());
    const [mesas, setMesas] = useState([]);
    const [reservaciones, setReservaciones] = useState([]);
    const [sectores, setSectores] = useState([]);


    const obtenerReservasHoy = async () => {

        let hoyInicio = dayjs().set('hour', 0).set('minute', 0).valueOf();
        let hoyFin = new dayjs().set('hour', 23).set('minute', 59).valueOf();

        let res = await buscarReservacionesDiaHora({fechaInicio: hoyInicio, fechaFin: hoyFin})
        setReservaciones(res)
    }

    const obtenerReservasOtroDia = async () => {

        let entidad = await obtenerEntidad();

        let fecha = entidad.fecha

        if (fecha) {

            let mananaInicio = dayjs(fecha).set('hour', 0).set('minute', 0).valueOf();
            let mananaFin = new dayjs(fecha).set('hour', 23).set('minute', 59).valueOf();

            setFecha(mananaInicio);

            let res = await buscarReservacionesDiaHora({fechaInicio: mananaInicio, fechaFin: mananaFin})
            setReservaciones(res)
        }


    }

    useEffect(() => {
        //Luego optimizar
        obtenerReservasHoy().then()

        setW([where('estado', '==', ESTADOSFILA[0].nombre)])

        obtenerCol('mesas').then((dox) => {
            if (dox.res) {
                setMesas(dox.data);
            }
        })

        obtenerCol('sectores').then((dox) => {
            if (dox.res) {
                setSectores(dox.data);
            }
        })


    }, [cargar]);
    return (
        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}

            >

                <Dialogo/>

                <DialogoFila/>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 6}}
                    spacing={2}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                        <Button
                            onClick={() => obtenerReservasHoy()}
                            startIcon={<Today/>}>Hoy</Button>
                    </Grid>


                    <Grid container size={{xs: 8, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                        <Formulario_Fecha props={props}/>
                    </Grid>

                    <Grid container size={{xs: 4, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                        <IconButton
                            onClick={() => obtenerReservasOtroDia()}
                            sx={{
                                backgroundColor: theme.palette.primary.main,
                                borderRadius: 1
                            }}
                        >
                            <Search sx={{fill: '#fff'}}/>
                        </IconButton>
                    </Grid>


                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end', mt: sCell ? 2 : 0}}>
                    <Typography
                        sx={{
                            fontSize: 20,
                            fontWeight: 600
                        }}>{dayjs(fecha).format('dddd / DD / MMM').toUpperCase().toUpperCase()}</Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{mt: 6}}
                    spacing={3}
                >


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 8}}
                        spacing={4}
                    >

                        {sectores.map((item, index) => (
                            <Grid key={index} container size={12}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Sectores_Vista_Dia item={item} reservas={reservaciones} mesas={mesas}
                                                            click={abrir}/>
                            </Grid>
                        ))}

                    </Grid>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 4}}>

                        <Grid container size={{xs: 8, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 24, fontWeight: 600}}>Fila de Ingreso</Typography>
                        </Grid>

                        <Grid container size={{xs: 4, sm: 12, md: 4}} sx={{justifyContent: 'flex-end'}}>
                            <Button
                                onClick={() => abrirFila()}
                                startIcon={<Add/>}>A Fila</Button>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            {data.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Fila item={item} click={abrirFila}/>
                                </Grid>
                            ))}

                        </Grid>

                    </Grid>

                </Grid>

            </Grid>


        </Grid>
    )

}
export default Seccion_Mesas_Dia
